<template>
  <div class="mx-auto flex w-full max-w-[1140px] flex-col gap-6 px-4 py-[70px]">
    <router-link to="/" class="text-base text-[#3a4250]">← 목록으로</router-link>
    <template v-if="item">
      <h1 class="text-3xl font-bold leading-[1.5] text-[#202632]">{{ item.title }}</h1>
      <p class="text-lg leading-[1.5] text-[#3a4250]">{{ item.desc }}</p>
    </template>
    <p v-else class="text-lg text-[#3a4250]">해당 성공사례를 찾을 수 없습니다.</p>
  </div>
</template>

<script>
import { successCases } from '@/data/home'

export default {
  name: 'SuccessCaseDetailView',
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  computed: {
    item() {
      return successCases.find((c) => c.id === this.id)
    },
  },
}
</script>
